import React, { useEffect, useState } from "react";
import { createCarePlanApi } from "../../api-helpers/PatientApiHelper";
import { CarePlanHistoryDto } from "patients-experience-client";
import { formatDate, formatDateTime } from "../../helper/dateFormatter";
import { Spinner } from "react-bootstrap";

// Sample Data for Care Plan History

interface CarePlanHistoryProps {
  selectedCarePlan: any;
}
export const CarePlanHistory: React.FC<CarePlanHistoryProps> = ({
  selectedCarePlan,
}) => {
  const [loading, setLoading] = useState(true);
  const [carePlanHistory, setCarePlanHistory] = useState<CarePlanHistoryDto[]>(
    []
  );

  const carePlanApi = createCarePlanApi();

  const loadCarePlanHistory = async () => {
    try {
      const response = await carePlanApi.carePlanControllerGetCarePlanHistory(
        selectedCarePlan.id
      );
      setCarePlanHistory(response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to load Care Plan History.", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCarePlanHistory();
  }, [selectedCarePlan]);

  const formatStatusTextColor = (status: string) => {
    switch (status) {
      case "Draft":
        return <span className="text-gray-500">Draft</span>;
      case "Review Pending":
        return <span className="text-warning">Review Pending</span>;
      case "Completed":
        return <span className="text-success">Completed</span>;
      default:
        return <span className="text-danger">{status}</span>;
    }
  };

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center mt-5">
          <Spinner />
        </div>
      ) : (
        <main>
          <h3 className="fs-16">
            {new Date(selectedCarePlan?.createdAt)
              .toLocaleDateString('en-US', { month: 'long', year: 'numeric',  }) || '-'
            }
          </h3>
          {carePlanHistory.map((item: CarePlanHistoryDto, index: number) => (
            <div className="border rounded mt-4" key={index}>
              <div className="d-flex align-items-start px-3 py-2 fs-14">
                <div className="flex-fill">
                  <strong>{item?.title}</strong>
                </div>
                <div>{formatStatusTextColor(item?.status)}</div>
              </div>
              <div className="d-flex bg-gray-FAF justify-content-between fs-12 px-3 py-2">
                <div className="text-light">{formatDateTime(item?.createdAt)}</div>
                <div className="d-flex align-items-center text-base">
                  <span className="material-symbols-outlined fs-18 me-1">
                    person
                  </span>
                  <span>{item?.createdBy?.name}</span>
                </div>
              </div>
            </div>
          ))}
        </main>
      )}
    </>
  );
};
